import { getScrollParent } from "../EasyProjectsCommon/getScrollParent";

const isVisible = (el: DOMRect, viewPort: DOMRect) => {
    return el.bottom > viewPort.top && el.top < viewPort.bottom;
};

const isCompletelyVisible = (el: DOMRect, viewPort: DOMRect) => {
    return el.top >= viewPort.top && viewPort.bottom >= el.bottom;
};

const getViewPort = (element: Element) => getScrollParent(element);

const isVisibleElement = (element: Element) => {
    const viewPortEl = getViewPort(element);
    if (!viewPortEl || !element) {
        return true;
    }

    return isVisible(element.getBoundingClientRect(), viewPortEl.getBoundingClientRect());
};

const isScrollIntoViewNeeded = (element: Element) => {
    const viewPortEl = getViewPort(element);
    if (!viewPortEl || !element) {
        return false;
    }

    const elRect = element.getBoundingClientRect();
    const viewPortRect = viewPortEl.getBoundingClientRect();

    const isCanFitIntoViewPort = elRect.height <= viewPortRect.height;

    const isInsideViewPort = isCanFitIntoViewPort ? isCompletelyVisible : isVisible;
    return !isInsideViewPort(elRect, viewPortRect);
};

const scrollIntoViewIfNeeded = (element: Element, options: ScrollIntoViewOptions) => {
    if (isScrollIntoViewNeeded(element)) {
        element.scrollIntoView(options);
    }
};

const isOutside = (container: HTMLElement, element: Node) => container && !container.contains(element);

export const domUtils = {
    isVisible: isVisibleElement,
    isScrollIntoViewNeeded,
    scrollIntoViewIfNeeded,
    isOutside,
} as const;
